import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { LoadingButton } from '@mui/lab';
import { Menu, MenuItem } from '@mui/material';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';

type Props = {
  formats: string[];
  onDownload: (format: string) => void;
  disabled?: boolean;
  loading?: boolean;
};

/**
 * Dropdown button to trigger report download in a chosen format.
 * Same style as list-view ExportButton (outlined, secondary).
 */
export const DownloadAs = ({ formats, onDownload, disabled, loading = false }: Props) => {
  const { $t } = useIntl();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (format: string) => {
    onDownload(format);
    handleClose();
  };

  return (
    <>
      <LoadingButton
        size="small"
        variant="outlined"
        color="secondary"
        startIcon={<FileDownloadOutlinedIcon />}
        endIcon={<ArrowDropDownIcon />}
        onClick={handleClick}
        loading={loading}
        loadingPosition="start"
        disabled={disabled}
      >
        {$t({
          id: 'common.actions.export',
          defaultMessage: 'Exportar',
        })}
      </LoadingButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {formats.map((format) => (
          <MenuItem key={format} onClick={() => handleSelect(format)}>
            {format.toUpperCase()}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
